import { Config } from 'src/config';

export const url = Config.backendServer;